import { c as _c } from "react/compiler-runtime";
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { McpToolName } from '@systemeio/ai-chat-types';
import { AiChatButton, AiChatWidgetProps, useWidgetControls } from '@systemeio/ai-chat-widget';
import { useRevalidateModules } from '@systemeio/util';
import { GrowthbookFlagsEnum } from 'growthbook/types';
import { lazy, Suspense } from 'react';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { pageRoute } from 'shared/constants/routes.constants';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import useUser from 'shared/hooks/use-user';
import { getPageRoute } from 'shared/utils/get-dynamic-page-route';
const Widget = lazy(() => import('@systemeio/ai-chat-widget').then(m => ({
  default: m.AiChatWidget
})));
export const AiChatTriggerButton = () => {
  const $ = _c(7);
  const {
    user
  } = useUser();
  const {
    open,
    setOpen
  } = useWidgetControls();
  const aiChatFeatureIsOn = useFeatureIsOn(GrowthbookFlagsEnum.AiChat);
  if (!aiChatFeatureIsOn || !user) {
    return null;
  }
  let t0;
  if ($[0] !== setOpen) {
    t0 = <AiChatButton onClick={() => {
      setOpen(_temp);
    }} />;
    $[0] = setOpen;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== open) {
    t1 = open && <AiChatModal />;
    $[2] = open;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <div className="ai-chat-widget">{t0}{t1}</div>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
const AiChatModal = () => {
  const $ = _c(7);
  const {
    setOpen
  } = useWidgetControls();
  const {
    revalidateModules
  } = useRevalidateModules();
  let t0;
  if ($[0] !== revalidateModules) {
    t0 = toolCall => {
      if (toolCall.output.isError) {
        return;
      }
      bb5: switch (toolCall.toolName) {
        case McpToolName.AssignContactTag:
        case McpToolName.RemoveContactTag:
        case McpToolName.CreateContact:
        case McpToolName.RemoveContact:
        case McpToolName.UpdateContact:
          {
            revalidateModules([RequestModuleEnum.Contacts], true);
            break bb5;
          }
        case McpToolName.CreateTag:
        case McpToolName.RemoveTag:
        case McpToolName.UpdateTag:
          {
            revalidateModules([RequestModuleEnum.Tags], true);
            break bb5;
          }
        case McpToolName.CreateNewsletter:
        case McpToolName.UpdateNewsletter:
        case McpToolName.SetNewsletterIncludedTags:
        case McpToolName.SetNewsletterExcludedTags:
          {
            revalidateModules([RequestModuleEnum.Newsletters], true);
            break bb5;
          }
        case McpToolName.CreateCampaign:
        case McpToolName.UpdateCampaign:
          {
            revalidateModules([RequestModuleEnum.Campaign], true);
            break bb5;
          }
        case McpToolName.DeleteCampaign:
          {
            revalidateModules([RequestModuleEnum.Campaign, RequestModuleEnum.CampaignStep], true);
            break bb5;
          }
        case McpToolName.CreateCampaignStep:
        case McpToolName.UpdateCampaignStep:
        case McpToolName.DeleteCampaignStep:
          {
            revalidateModules([RequestModuleEnum.CampaignStep], true);
            break bb5;
          }
        case McpToolName.CreateAutomationRule:
        case McpToolName.UpdateAutomationRule:
        case McpToolName.DeleteAutomationRule:
          {
            revalidateModules([RequestModuleEnum.AutomationRule], true);
            break bb5;
          }
        case McpToolName.CreateCoupon:
        case McpToolName.UpdateCoupon:
        case McpToolName.DeleteCoupon:
          {
            revalidateModules([RequestModuleEnum.Coupons], true);
            break bb5;
          }
        case McpToolName.CreatePricePlan:
        case McpToolName.UpdatePricePlan:
        case McpToolName.DeletePricePlan:
          {
            revalidateModules([RequestModuleEnum.PricePlans], true);
            break bb5;
          }
        case McpToolName.CreateDigitalProduct:
        case McpToolName.UpdateDigitalProduct:
        case McpToolName.DeleteDigitalProduct:
          {
            revalidateModules([RequestModuleEnum.DigitalProducts], true);
            break bb5;
          }
        case McpToolName.CreateFunnel:
          {
            revalidateModules([RequestModuleEnum.Funnels], true);
            break bb5;
          }
        case McpToolName.CreateFunnelStep:
        case McpToolName.SaveContent:
        case McpToolName.SaveFunnelPageContent:
          {
            revalidateModules([RequestModuleEnum.FunnelsStep], true);
            break bb5;
          }
        default:
      }
    };
    $[0] = revalidateModules;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleToolCallOutput = t0;
  let t1;
  if ($[2] !== setOpen) {
    t1 = () => setOpen(false);
    $[2] = setOpen;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== handleToolCallOutput || $[5] !== t1) {
    t2 = <Suspense fallback={null}><Widget UpgradeLink={_temp2} onToolCallOutput={handleToolCallOutput} onClose={t1} /></Suspense>;
    $[4] = handleToolCallOutput;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
function _temp(prev) {
  return !prev;
}
function _temp2(props) {
  return <LinkWithoutPrefetch href={getPageRoute(pageRoute.ProfileUserPlan)} {...props} />;
}